export var firstLastNoMargin = 'AKS6P';
export var firstNoMargin = 'tEd0M';
export var hideIfFirstChild = 'KKMDy';
export var hideIfLastChild = 'k-ROU';
export var hideOnPrint = 'TjRAW';
export var lastNoMargin = 'ENpq9';